import moment from "moment";
import { SamPlayListItemDef } from "userful-chronos-app-common-js/dist/models/sam/SAMPlaylist";
import { APP_IDS, APP_NAMES, UserfulSecurityData } from "userful-chronos-app-common-js/dist/models/common";
import React from "react";
import { ClearanceLevel } from "userful-chronos-app-common-js/dist/models/usermgt/clearanceLevel";

export const AppsConfig = [
    {
        id: APP_IDS.Decisions,
        name: APP_NAMES.ControlRoom,
        title: "ChronosLauncher.Diamond.tooltip",
        titleIcon: <img alt="D" src="./assets/V2_icons/Decisions.png" />,
    },
    // {
    //     id: APP_IDS.GCM,
    //     name: APP_NAMES.GCM,
    //     title: "ChronosLauncher.GCM.tooltip",
    //     titleIcon: (<img alt='GCM' src="./assets/V2_icons/GCM.png" />),
    // },
    {
        id: APP_IDS.uConduct,
        name: APP_NAMES.uConduct,
        title: "ChronosLauncher.uConduct.tooltip",
        titleIcon: <img alt="uConduct" src="./assets/V2_icons/uConduct.png" />,
    },
    {
        id: APP_IDS.Trends,
        name: APP_NAMES.Trends,
        title: "ChronosLauncher.Topaz.tooltip",
        titleIcon: <img alt="T" src="./assets/V2_icons/Trends.png" />,
    },
    {
        id: APP_IDS.Spaces,
        name: APP_NAMES.Spaces,
        title: "ChronosLauncher.Sapphire.tooltip",
        titleIcon: <img alt="S" src="./assets/V2_icons/Spaces.png" />,
    },
    {
        id: APP_IDS.Artistic,
        name: APP_NAMES.Artistic,
        title: "ChronosLauncher.Emerald.tooltip",
        titleIcon: <img alt="E" src="./assets/V2_icons/Engage.png" />,
    },
    {
        id: APP_IDS.Switch,
        name: APP_NAMES.Switch,
        title: "ChronosLauncher.uControl.tooltip",
        // titleIcon: (<FontAwesomeIcon icon={faCodePullRequest} />),
        titleIcon: <img alt="uControl" src="./assets/V2_icons/uControl.png" />,
    },
];

export const getSecondsFromDuration = (durationValue: any): number => {
    if (!durationValue) {
        return 0;
    }
    if (isNaN(durationValue)) {
        return moment.duration(durationValue).asSeconds();
    }
    return Number(durationValue);
};

export const getPlayListDurationInSeconds = (items: SamPlayListItemDef[]): string => {
    let totalDuration = 0;
    items.forEach((item) => {
        let totalItemDuration =
            getSecondsFromDuration(item.behaviour.activationDuration) +
            getSecondsFromDuration(item.behaviour.playDuration);
        // getSecondsFromDuration(item.behaviour.preStartDuration);
        if (item.behaviour.repeatConfig.times.times > 0) {
            totalItemDuration = totalItemDuration * item.behaviour.repeatConfig.times.times;
        }
        if (getSecondsFromDuration(item.behaviour.repeatConfig.duration) > 0) {
            totalItemDuration = Math.min(
                totalItemDuration,
                getSecondsFromDuration(item.behaviour.repeatConfig.duration),
            );
        }
        totalDuration += totalItemDuration;
    });
    if (totalDuration > 0) {
        return ` ${moment.duration(totalDuration, "seconds").humanize()}`;
    }
    return " Unknown Duration";
};
